import { render } from "./SingleUclMatchResult.vue?vue&type=template&id=055869d6&scoped=true"
import script from "./SingleUclMatchResult.vue?vue&type=script&lang=js"
export * from "./SingleUclMatchResult.vue?vue&type=script&lang=js"

import "./SingleUclMatchResult.vue?vue&type=style&index=0&id=055869d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055869d6"]])

export default __exports__